"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePermissions = void 0;
var react_1 = require("@casl/react");
var context_1 = require("../context");
var usePermissions = function () { return (0, react_1.useAbility)(context_1.AbilityContext); };
exports.usePermissions = usePermissions;
//# sourceMappingURL=usePermissions.js.map